import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { hotjar } from 'react-hotjar';
import { BrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

declare global {
  interface Window {
    dataLayer?: object[];
  }
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
});

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID || '',
};

TagManager.initialize(tagManagerArgs);

hotjar.initialize(
  parseInt(process.env.REACT_APP_HJ_ID || '0'),
  parseInt(process.env.REACT_APP_HJ_VERSION || '0')
);

ReactDOM.render(
  <BrowserRouter>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
